import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import LayoutListFormStyle from './LayoutListFormStyle'
import type { LayoutListFormBrandType, LayoutListBrandForms } from './layoutListTypes'

const FORM_MAP: LayoutListBrandForms = {
  [BrandFormEnum.STYLE]: LayoutListFormStyle,
}

const LayoutListFormBrand: LayoutListFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(LayoutListFormBrand) as typeof LayoutListFormBrand
